import { useLocation } from 'react-router';

import type { InviteLinkArgs } from 'widgets/poker-home-games-widget/types/common';

const useGetArgs = () => {
  const { search } = useLocation();
  const urlParams = new URLSearchParams(search);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let args = {} as InviteLinkArgs;

  if (!search) {
    return { args, urlParams };
  }

  try {
    args = JSON.parse(atob(urlParams.get('args') || ''));

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    args = {} as InviteLinkArgs;
  }

  return { args, urlParams };
};

export default useGetArgs;
